export default __webpack_public_path__ + "static/media/06.6acd5419.jpg";